import { render, staticRenderFns } from "./CapitalDistribution.vue?vue&type=template&id=3b6846eb&scoped=true"
import script from "./CapitalDistribution.vue?vue&type=script&lang=js"
export * from "./CapitalDistribution.vue?vue&type=script&lang=js"
import style0 from "./CapitalDistribution.vue?vue&type=style&index=0&id=3b6846eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6846eb",
  null
  
)

export default component.exports